import React from "react";
import Card from "./Card";

function Home() {
  return (
    <>
      <section id="header" className="d-flex align-items-center">
        <div className="container-fluid nav_bg">
          <div className="row">
            <div className="col-10 mx-auto">
              <div className="row pt-5">
                <div className="pt-5 pt-lg-0 order-2 order-lg-1 d-flex justify-content-center flex-column">
                  <h1 className="text-center">
                    Celebron IT Solutions
                  </h1>
                  <h2 className="text-center">
                    DevOps, Cloud &amp; Platform Engineering Consulting — Netherlands
                  </h2>

                  <p className="my-3">
                    Specialising in DevOps consulting, we help businesses design, optimise, and modernise their AWS, Azure, and on-premises environments. Our expertise includes cloud implementation, infrastructure automation, containerisation, cloud migration, CI/CD, observability, and cloud modernisation — ensuring secure, efficient, and high-performing systems. With deep knowledge of cloud and hybrid architectures, we enable organisations to streamline operations, adopt container technologies, leverage the public cloud, and manage costs effectively.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-5">
            <div>
              <h2 className="text-center">Our Services</h2>
            </div>
            <div className="container-fluid mb-5">
              <div className="row justify-content-center">
                <div className="col-10 mx-auto">
                  <div className="row gy-4 justify-content-center">
                    <Card
                      title="DevOps Engineering"
                      imgsrc="assets/devops.png"
                      text="End-to-end DevOps implementation: CI/CD pipelines, build automation, release management, and engineering culture transformation for faster, reliable software delivery."
                    />
                    <Card
                      title="Platform Engineering"
                      imgsrc="assets/platform.png"
                      text="Internal developer platforms, self-service infrastructure, and golden-path tooling that reduce cognitive load and accelerate your engineering teams."
                    />
                    <Card
                      title="AWS / Azure Cloud Engineering"
                      imgsrc="assets/cloud.png"
                      text="Cloud architecture, landing zones, and managed services on AWS and Microsoft Azure — designed for security, scalability, and operational excellence."
                    />
                    <Card
                      title="On-Premises / Cloud Migration"
                      imgsrc="assets/migration.png"
                      text="Lift-and-shift and re-architect migrations from on-premises infrastructure to AWS or Azure, with minimal disruption and maximum reliability."
                    />
                    <Card
                      title="Observability Engineering"
                      imgsrc="assets/observability.png"
                      text="Full-stack monitoring, logging, distributed tracing, and alerting — so your teams detect, diagnose, and resolve issues before they impact users."
                    />
                    <Card
                      title="Cloud Cost Optimization"
                      imgsrc="assets/cost.png"
                      text="FinOps practices, right-sizing, reserved instances, and cloud spend governance to reduce your cloud bill without sacrificing performance."
                    />
                    <Card
                      title="DevOps Training"
                      imgsrc="assets/training.png"
                      text="Hands-on team training on Kubernetes, Terraform, CI/CD pipelines, AWS, and Azure — building lasting internal capability for your engineering organisation."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
